import React from 'react';

import { Paper, Stack, Typography } from '@mui/material';

import { InfoWalkmeCrumb } from 'features/info_hover/InfoHover';

import styles from './InfoCard.module.css';

export function InfoCard({
  num,
  metric,
  classOveride = undefined,
}: {
  num: string | number;
  metric: string | React.ReactNode;
  classOveride?: string;
}) {
  return (
    <Paper className={classOveride || styles.subscription_statistics_tile}>
      <Typography>{metric}</Typography>
      <Typography variant="h2">{num}</Typography>
    </Paper>
  );
}

export function InfoCardContainer({ children }: React.PropsWithChildren) {
  return (
    <Stack
      direction="row"
      gap="1em"
      className={styles.subscription_statistics_tile_container}
    >
      {children}
    </Stack>
  );
}

export function QuotaInfoBlock({
  total_quota,
  used_quota,
  unusued_quota,
}: {
  total_quota: number;
  used_quota: number;
  unusued_quota: number;
}) {
  return (
    <Stack
      direction="row"
      gap="1em"
      className={styles.subscription_quota_tile_container}
    >
      <InfoCard num={total_quota} metric="Total Quota" />
      <InfoCard
        num={used_quota}
        metric={
          <>
            Used
            <InfoWalkmeCrumb elId="used-quota-info" />
          </>
        }
        classOveride={styles.subscription_statistics_tile_background}
      />
      <InfoCard
        num={unusued_quota}
        metric="Unused"
        classOveride={styles.subscription_statistics_tile_background}
      />
    </Stack>
  );
}
